import { useEffect } from 'react';
import { toast } from 'react-toastify';
import RefundTable from '../components/RefundTable';
import { SocketRPC, socketEmit } from '../lib/socket';
import { useRefundSearchParams, useRefunds } from '../store/refunds';
import useUser from '../store/user';

const RefundStatusPage = () => {
	const { user } = useUser();
	const { producerKey, orderSourceKey, partnerKey } = user || {};
	const { refunds, setRefunds, refundsLoaded, setRefundsLoaded } = useRefunds();
	const { refundSearchParams, setRefundSearchParams, activePage, setActivePage } = useRefundSearchParams();

	useEffect(() => {
		setRefundsLoaded(false);
		Promise.resolve()
			.then(() => {
                const sortDirection = refundSearchParams?.sortDirection === 1 ? 'ASC' : 'DESC';
				return socketEmit(SocketRPC.SearchRefunds, {
					...(refundSearchParams || {}),
					user,
					producerKey,
					orderSourceKey,
					partnerKey,
					pageIndex: activePage - 1,
					pageSize: 10,
                    sortField: 'orderLateDelivery',
                    sortDirection,
				});
			})
			.then((res) => {
				if (!res.success) {
					setRefunds([]);
					throw new Error(res.error);
				}
				setRefunds(res.refundDisputes);
				setRefundsLoaded(true);
			})
			.catch((err) => {
				toast.error(`Error searching refunds. Please try again`);
				setRefundsLoaded(true);
				console.log(`Could not search refunds`, err);
			});
	}, [JSON.stringify(refundSearchParams), activePage]);

	const paginationProps = {
		activePage,
		setActivePage,
	};

	const RefundTableProps = {
		refunds,
		refundsLoaded,
		setRefundSearchParams,
		refundSearchParams,
		paginationProps,
	};

	return RefundTable(RefundTableProps);
};

export default RefundStatusPage;
